import { render, staticRenderFns } from "./returnTop.vue?vue&type=template&id=f61396bc"
import script from "./returnTop.vue?vue&type=script&lang=js"
export * from "./returnTop.vue?vue&type=script&lang=js"
import style0 from "./returnTop.vue?vue&type=style&index=0&id=f61396bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports